<mat-toolbar class="h-[var(--pb-toolbar-height,8rem)] bg-white">
  <pb-header></pb-header>
</mat-toolbar> 
<router-outlet></router-outlet> 